import { useAuthStore } from '@shared/stores/authStore';

/**
 * Permission gating for the logged-in member. An admin-capable member carries the
 * tenant role permissions (e.g. `support:request:read:all`, `members:requests:approve`)
 * on `user.permissions`. `admin:full:access` is the tenant wildcard and grants all.
 */
const WILDCARD = 'admin:full:access';

export function getUserPermissions(): string[] {
  return useAuthStore.getState().user?.permissions ?? [];
}

export function hasPermission(permission: string): boolean {
  const perms = getUserPermissions();
  return perms.includes(WILDCARD) || perms.includes(permission);
}

export function hasAnyPermission(...permissions: string[]): boolean {
  return permissions.some(hasPermission);
}

/** Reactive hook — re-renders when the user's permissions change (login/switch). */
export function useHasPermission(permission: string): boolean {
  return useAuthStore((state) => {
    const perms = state.user?.permissions ?? [];
    return perms.includes(WILDCARD) || perms.includes(permission);
  });
}

export function useHasAnyPermission(...permissions: string[]): boolean {
  return useAuthStore((state) => {
    const perms = state.user?.permissions ?? [];
    if (perms.includes(WILDCARD)) return true;
    return permissions.some((p) => perms.includes(p));
  });
}
